import React, { Component } from 'react';
import { Upload, Icon, Button, message } from 'antd';

import localDb from '@util/localDb';
import { common } from '@api/req';
import { queryFilePreview } from '@api/pub/attachment';

/**
 * 文件上传
 */
class UploadFile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fileList: [],
      style: {},
    };
  }

  componentDidMount() {
    if (this.props.value === 'reset') {
      this.setState({ fileList: [] });
      return;
    }
    if (this.props.value && this.props.value.length > 0 && this.state.fileList.length === 0) {
      this.setState({ fileList: this.wrapFile(this.props.value) });
    }
  }

  componentWillReceiveProps(props) {
    if (props.value === 'reset') {
      this.setState({ fileList: [] });
      return;
    }
    const fileList = this.wrapFile(props.value);
    const oldList = this.state.fileList;
    if (oldList.length === 0 && fileList && fileList.length > 0) {
      this.setState({ fileList });
    }
  }

  wrapFile = fileArr => {
    let files = [];
    if (fileArr && fileArr.length > 0) {
      files = fileArr.map((file, index) => {
        return {
          uid: file.uuid || index,
          uuid: file.uuid || index,
          name: file.name,
          url: file.url,
          status: 'done',
        };
      });
    }
    return files;
  };

  /**
   * 上传文件之前的钩子，参数为上传的文件，若返回 false 则停止上传。
   * 支持返回一个 Promise 对象，Promise 对象 reject 时则停止上传，resolve 时开始上传。
   * 注意：IE9 不支持该方法。
   */
  handleBefore = info => {
    const excelContentTypeArr = [
      'application/vnd.ms-excel', // .xls,.xlt,.xla
      'application/wps-office.xls', // .xls(WPS)
      'application/wps-office.xlsx', // .xlsx(WPS)
      'application/vnd.ms-excel.addin.macroEnabled.12', // .xlam
      'application/vnd.ms-excel.sheet.macroEnabled.12', // .xlsm
      'application/vnd.ms-excel.template.macroEnabled.12', // .xltm
      'application/vnd.ms-excel.sheet.binary.macroEnabled.12', // .xlsb
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
      'application/vnd.openxmlformats-officedocument.spreadsheetml.template', // .xltx
    ];
    const typeIndex = excelContentTypeArr.indexOf(info.type);
    return new Promise((resolve, reject) => {
      if (typeIndex === -1) {
        message.error('请上传excel格式的文件');
        reject();
      } else {
        resolve();
      }
    });
  };

  handleChange = info => {
    if (info.error && info.error.status !== 200) {
      return false;
    }

    let { fileList } = info;
    // 1. Limit the number of uploaded files
    const { limit } = this.props;
    if (limit) {
      fileList = fileList.reverse().slice(0, limit);
    }

    // 2. read from response and show file link
    // 只拿最新的一个文件
    fileList = fileList.map(file => {
      if (file.response) {
        // Component will show file.url as link
        // file.response.data是一个数组
        if (file.response.data && file.response.data.length > 0) {
          file.url = file.response.data[0].url;
          file.uuid = file.response.data[0].uuid;
        } else {
          message.error('上传失败，请重新上传');
        }
      }
      return file;
    });

    // 3. filter successfully uploaded files according to response from server
    fileList = fileList.filter(file => {
      if (file.response) {
        return file.response.statusCode === 200;
      }
      return true;
    });

    this.setState({ fileList });
    this.props.onChange && this.props.onChange(this.formatFiles(fileList));
    const { handleUpload } = this.props;
    if (typeof handleUpload === 'function') {
      handleUpload(fileList);
    }
  };

  formatFiles = fileList => {
    const files = [];
    fileList.map((item, index) => {
      files[index] = {
        uuid: item.uuid,
        name: item.name,
        url: item.url,
      };
      return item;
    });
    return files;
  };

  render() {
    const { key, data, isExcel, isPreview, uploadType, onRemove, handleClick } = this.props;
    const action = uploadType ? common.FILE_UPLOAD : common.UPLOAD;
    return (
      <Upload
        key={key}
        name="files"
        data={data || {}}
        fileList={this.state.fileList}
        beforeUpload={isExcel ? this.handleBefore : null}
        action={`${action}`}
        headers={{
          Authorization: `${localDb.get('token')}`,
        }}
        onRemove={onRemove || null}
        onChange={this.handleChange}
        onPreview={isPreview ? file => queryFilePreview(file) : null}
      >
        <Button
          type="ghost"
          onClick={handleClick} // 同一个页面有多个upload,记录下标
          style={this.state.style}
          disabled={this.props.disabled ? this.props.disabled : false}
        >
          <Icon type="upload" /> 点击上传
        </Button>
      </Upload>
    );
  }
}

export default UploadFile;

UploadFile.propTypes = {};

/**
 * 包装文件
 * @param  {[type]} arr [description]
 * @return {[type]}     [description]
 */
export function wrapFile(fileArr) {
  let files = [];
  if (fileArr && fileArr.length > 0) {
    files = fileArr.map((file, index) => {
      return {
        uid: file.uuid || index,
        name: file.name,
        url: file.url,
        status: 'done',
      };
    });
  }
  return files;
}



// WEBPACK FOOTER //
// ./src/components/comm/upload/UploadFile.js